<template>
  <div>
    <base-header :pageName="headerTitle" :popup="true"></base-header>

    <section id="wrap">
        <div class="search-input">
            <input type="search" v-model="searchUsername" v-on:keyup.enter="getMyOrgList()" placeholder="이름을 입력해주세요." >
        </div>
        <ul class="search-result-leader">
            <li v-for="(myOrg,index) in myOrgList" v-bind:key="index">
                <button type="button" @click="selectUserid(myOrg.userid)">
                    <em :class="{ epLv: 'COG01' == myOrg.orgnzPstn, epLv1: 'COG02' == myOrg.orgnzPstn, epLvA1: 'COGA2' == myOrg.orgnzPstn, epLv2: 'COG03' == myOrg.orgnzPstn, epLv3: 'COG04' == myOrg.orgnzPstn, epLv4: 'COG05' == myOrg.orgnzPstn, epLv5: 'COG06' == myOrg.orgnzPstn }"></em>
                    <strong>{{ myOrg.username }}</strong>
                    <i>{{ myOrg.userid }}</i>
                    <span><em></em></span>
                </button>
            </li>
        </ul>
        <!-- 검색 결과 실패시-->
        <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
          <div slot="no-more"></div>
          <div slot="no-results">
            <div class="search-resutl-None">
                <p>등록된 에듀플래너가 없습니다.<br/>다시 검색해 주세요.</p>
            </div> 
          </div>
        </infinite-loading>
    </section>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "orgList",
  components: {
    InfiniteLoading
  },
  data() {
    return {
      searchUsername: "",
			tot:0,
			offset: 0,	 //현재 가지고있는 갯수
			size : 10,	//한번에 가져오는 수
      myOrgList: [],
      headerTitle: 'EP 목록',
    };
  },
  methods: {
    infiniteHandler: function($state) {
      var that = this;
      var parameters = {
        searchUsername: this.searchUsername,
        // selfExcept: 'Y', // 자기 자신은 제외
        offset: this.offset,
        size: this.size
      };
      this.$api.myschedule.getMyOrgList(parameters)
        .then(function(res) {
          that.tot = res.totCnt;
          var list = res.myOrgList;
          if (list.length) {
            that.offset += that.size;
            that.myOrgList = that.myOrgList.concat(list);
            $state.loaded();
            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    getMyOrgList() { // 로그인한 지국장의 조직 목록조회
      this.tot = 0;
			this.offset = 0
			this.size = 10
      this.myOrgList = [];
      this.$refs.InfiniteLoading.stateChanger.reset();
    },
    selectUserid : function(pUserid) { // 조직원 중 한명을 선택해서 고객목록 팝업 호출.
        this.$router.push({ name: "cust-search", params:{userId:pUserid}}).catch(function() {}).then((() =>window.scrollTo(0,0) ));
    }
  },
};
</script>
